
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WidgetProductCardBaseComponent } from 'projects/shared/lib/components/shared/content/widget/productcard/widget-product-card-base.component';
import { ProductListItemListModule } from '../../../product/list/item/list/product-list-item-list.module';
import { ProductListItemGridModule } from '../../../product/list/item/grid/product-list-item-grid.module';

@Component({
    selector: 'app-widget-product-card',
    imports: [
    FormsModule,
    ProductListItemListModule,
    ProductListItemGridModule
],
    templateUrl: './widget-product-card.component.html',
    styleUrls: ['./widget-product-card.component.scss']
})
export class WidgetProductCardComponent extends WidgetProductCardBaseComponent {}
